import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation, Trans } from 'i18n';
import Link from 'components/Link';

import Activity from './Activity';

function ApplicationChangeRating({
  createdAt,
  createdBy,
  ratingOption,
  inApplicationContext,
  inJobPositionContext,
  application,
  t,
  onClick,
  ...rest
}) {
  return (
    <Activity
      icon="user"
      createdAt={createdAt}
      createdBy={createdBy}
      {...rest}
      action={
        <>
          {ratingOption &&
            (inApplicationContext ? (
              <>
                {t('ApplicationChangeRating_changedRatingTo')}{' '}
                <b>{t(ratingOption.value)}</b>
              </>
            ) : (
              <Trans
                i18nKey={`ApplicationChangeRating_changedRatingTo--extended${
                  inJobPositionContext ? 'InJobPosition' : ''
                }`}
              >
                changed rating of{' '}
                <Link
                  onClick={onClick}
                  to={`/candidates/${application.candidate.pk}/${application.pk}`}
                >
                  {{
                    candidate: `${application.candidate.firstName} ${application.candidate.lastName}`,
                  }}
                </Link>{' '}
                application{' '}
                {!inJobPositionContext ? (
                  <>
                    for position{' '}
                    <b>{{ position: application.jobPosition.position }}</b>
                  </>
                ) : (
                  ''
                )}{' '}
                to <b>{{ rating: t(ratingOption.value) }}</b>
              </Trans>
            ))}
          {!ratingOption &&
            (inApplicationContext ? (
              t('ApplicationChangeRating_removedRating')
            ) : (
              <Trans
                i18nKey={`ApplicationChangeRating_removedRating--extended${
                  inJobPositionContext ? 'InJobPosition' : ''
                }`}
              >
                removed rating of{' '}
                <Link
                  to={`/candidates/${application.candidate.pk}/${application.pk}`}
                >
                  {{
                    candidate: `${application.candidate.firstName} ${application.candidate.lastName}`,
                  }}
                </Link>{' '}
                application{' '}
                {!inJobPositionContext ? (
                  <>
                    for position{' '}
                    <b>{{ position: application.jobPosition.position }}</b>
                  </>
                ) : (
                  ''
                )}
              </Trans>
            ))}
        </>
      }
    />
  );
}

ApplicationChangeRating.propTypes = {
  createdAt: PropTypes.string,
  createdBy: PropTypes.object,
  ratingOption: PropTypes.object,
  inApplicationContext: PropTypes.bool,
  inJobPositionContext: PropTypes.bool,
  application: PropTypes.object,

  // fired whenever user clicks the activity and is navigated to the link to the activities page,
  // e.g. used to set notification as read
  onClick: PropTypes.func,

  // From HoCs
  t: PropTypes.func.isRequired,
};

export default withTranslation('translation')(ApplicationChangeRating);
